// removed by extract-text-webpack-plugin
module.exports = {"alert":"App__alert__I4U0d","msg":"App__msg__ceihP","toggleAlert":"App__toggleAlert__1Nux0","errorBox":"App__errorBox__1acDc","verticalCenter":"App__verticalCenter__3QTtL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.css
// module id = 3648
// module chunks = 0